import React, { useCallback } from 'react';
import { map } from 'ramda';
import Form from 'js/components/common/Form';
import { Button } from 'js/components/common/Button';
import * as dateUtils from 'js/utils/date.util';
import { ManagedPopup } from 'js/components/common/Popup';
import { I18n } from 'js/components/common/I18n';
import { useTranslations } from 'js/hooks/i18n';
import { DatePicker } from 'js/components/common/Fields/DatePicker';
import { useCombinedOnClose } from 'js/components/common/PopupManager';

import style from './AgeVerificationPopup.scss';

export const popupClassNames = {
    inner: style.popupInner
};

export const AgeVerificationPopup = ({ onClose, controls }) => {
    const t = useTranslations('playtech.mobile.system.age-verification.');
    const title = t('title');
    const closePopup = useCombinedOnClose(onClose);

    const validate = useCallback((values) => {
        if (!dateUtils.has18Years(values.dateOfBirth)) {
            return map(() => t('error'), values);
        }
    }, [t]);

    return (
        <ManagedPopup title={title} classNames={popupClassNames} isModal={true} controls={controls}>
            <p><I18n t={t} tKey={'description'} /></p>
            <Form
                validate={validate}
                onSubmit={closePopup}
                initialValues={{ dateOfBirth: new Date().valueOf() }}
                render={({ handleSubmit, submitting }) => (
                    <form onSubmit={event => event.preventDefault()}>
                        <DatePicker
                            label={t('dateOfBirth')}
                            name="dateOfBirth"
                        />
                        <p><I18n t={t} tKey={'terms'} /></p>
                        <p>
                            <Button
                                type="button"
                                view="primary"
                                disabled={submitting}
                                onClick={handleSubmit}
                            >
                                {t('submit')}
                            </Button>
                        </p>
                    </form>
                )}
            />
        </ManagedPopup>
    );
};
